import { motion } from "framer-motion";
import SectionHead from "./SectionHead";

const TAGS = [
  "Freunde treffen",
  "Feierabend",
  "Date Night",
  "Geburtstage",
  "Spieleabende",
  "Firmenevents",
  "Turniere",
];

export default function Anlaesse() {
  return (
    <section id="anlaesse" data-testid="anlaesse-section" className="px-6 py-24 md:px-10 md:py-36">
      <div className="mx-auto max-w-5xl">
        <SectionHead center chapter="03" eyebrow="Für jeden Anlass" title="Wofür auch immer du kommst." />
        <motion.div
          className="mt-14 flex flex-wrap justify-center gap-4"
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          variants={{ show: { transition: { staggerChildren: 0.07 } } }}
        >
          {TAGS.map((tag) => (
            <motion.span
              key={tag}
              data-testid={`tag-${tag.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              variants={{
                hidden: { opacity: 0, y: 20 },
                show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } },
              }}
              className="cursor-default rounded-full border border-[#c9a24a]/30 px-7 py-3 text-sm uppercase tracking-[0.14em] text-[#c9bda9] transition-colors duration-300 hover:border-[#c9a24a] hover:bg-[#5c1a1f] hover:text-[#f4ecdd]"
            >
              {tag}
            </motion.span>
          ))}
        </motion.div>
        <motion.p
          data-testid="anlaesse-closing"
          className="mx-auto mt-14 max-w-2xl text-center font-display text-xl italic leading-relaxed text-[#e3c988] md:text-2xl"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
        >
          Ob zwei oder zwanzig Leute, ob Turnier oder Feierabend — hier zählt nur die Zeit zusammen.
        </motion.p>
        <motion.p
          data-testid="anlaesse-rental-note"
          className="mx-auto mt-8 max-w-2xl text-center text-sm leading-relaxed text-[#c9bda9] md:text-base"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.45, ease: [0.22, 1, 0.36, 1] }}
        >
          Du willst einen ganzen Raum — oder gleich den ganzen Laden — für dein Event mieten? Auch
          das ist möglich: Schreib uns dafür einfach per Mail an{" "}
          <a
            href="mailto:vintagebillard@gmail.com"
            data-testid="anlaesse-mail-link"
            className="text-[#e3c988] underline decoration-[#c9a24a]/40 underline-offset-4 transition-colors duration-300 hover:text-[#c9a24a]"
          >
            vintagebillard@gmail.com
          </a>
          .
        </motion.p>
      </div>
    </section>
  );
}
